/**
 * Curved stage list with pending / routing / active / done states.
 */
export default function StageRail({
  stages = [],
  activeStage = 1,
  routingStage = null,
  side = "left",
}) {
  return (
    <div className={`stage-rail stage-rail-${side}`}>
      {stages.map((stage) => {
        const id = stage.id;
        let state = "pending";
        if (routingStage === id) {
          state = "routing";
        } else if (id === activeStage) {
          state = "active";
        } else if (id < activeStage) {
          state = "done";
        }

        return (
          <div key={id} className={`stage-item ${state}`}>
            {side === "right" ? <span className="stage-connector" /> : null}
            {side === "left" ? (
              <>
                <span className="stage-label">{stage.name}</span>
                <span className="stage-dot" />
                <span className="stage-connector" />
              </>
            ) : (
              <>
                <span className="stage-dot" />
                <span className="stage-label">{stage.name}</span>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
}
